import { snippetRef } from './consts';
export default function(editor, opts = {}) {
  const bm = editor.BlockManager;

  if (opts.blocks.indexOf(snippetRef) >= 0) {
    const style = `
    <style>
    .${snippetRef} {
      min-height: 50px;
    }
    </style>
`;
    bm.add(snippetRef, {
      label: `
      <?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 x="0px" y="0px" viewBox="0 0 24 24" width="32" height="50" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path d="M23.4,8.6h-6.6c-0.7,0-1.3-0.6-1.3-1.3V0.6c0-0.4,0.3-0.6,0.6-0.6h2.1c0.4,0,0.6,0.3,0.6,0.6v4.5h4.5c0.4,0,0.6,0.3,0.6,0.6
	v2.1C24,8.3,23.7,8.6,23.4,8.6z M8.6,7.3V0.6C8.6,0.3,8.3,0,7.9,0H5.8C5.4,0,5.1,0.3,5.1,0.6v4.5H0.6C0.3,5.1,0,5.4,0,5.8v2.1
	c0,0.4,0.3,0.6,0.6,0.6h6.6C8,8.6,8.6,8,8.6,7.3z M8.6,23.4v-6.6c0-0.7-0.6-1.3-1.3-1.3H0.6c-0.4,0-0.6,0.3-0.6,0.6v2.1
	c0,0.4,0.3,0.6,0.6,0.6h4.5v4.5c0,0.4,0.3,0.6,0.6,0.6h2.1C8.3,24,8.6,23.7,8.6,23.4z M18.9,23.4v-4.5h4.5c0.4,0,0.6-0.3,0.6-0.6
	v-2.1c0-0.4-0.3-0.6-0.6-0.6h-6.6c-0.7,0-1.3,0.6-1.3,1.3v6.6c0,0.4,0.3,0.6,0.6,0.6h2.1C18.6,24,18.9,23.7,18.9,23.4z"/>
</svg>

      <div>${opts.labelSnippet}</div>`,
      content: `<div class="${snippetRef}" data-gjs-type="${snippetRef}"></div>${style}`,
      category: opts.labelSnippetCategory,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelSnippet
      }?"></i>
        </a>
      </span>
    `,
    });

    bm.add(snippetRef + 'frequently_used', {
      label: `
      <?xml version="1.0" encoding="utf-8"?>
<svg version="1.1" id="Layer_1" focusable="false" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
	 x="0px" y="0px" viewBox="0 0 24 24" width="32" height="50" style="enable-background:new 0 0 24 24;" xml:space="preserve">
<path d="M23.4,8.6h-6.6c-0.7,0-1.3-0.6-1.3-1.3V0.6c0-0.4,0.3-0.6,0.6-0.6h2.1c0.4,0,0.6,0.3,0.6,0.6v4.5h4.5c0.4,0,0.6,0.3,0.6,0.6
	v2.1C24,8.3,23.7,8.6,23.4,8.6z M8.6,7.3V0.6C8.6,0.3,8.3,0,7.9,0H5.8C5.4,0,5.1,0.3,5.1,0.6v4.5H0.6C0.3,5.1,0,5.4,0,5.8v2.1
	c0,0.4,0.3,0.6,0.6,0.6h6.6C8,8.6,8.6,8,8.6,7.3z M8.6,23.4v-6.6c0-0.7-0.6-1.3-1.3-1.3H0.6c-0.4,0-0.6,0.3-0.6,0.6v2.1
	c0,0.4,0.3,0.6,0.6,0.6h4.5v4.5c0,0.4,0.3,0.6,0.6,0.6h2.1C8.3,24,8.6,23.7,8.6,23.4z M18.9,23.4v-4.5h4.5c0.4,0,0.6-0.3,0.6-0.6
	v-2.1c0-0.4-0.3-0.6-0.6-0.6h-6.6c-0.7,0-1.3,0.6-1.3,1.3v6.6c0,0.4,0.3,0.6,0.6,0.6h2.1C18.6,24,18.9,23.7,18.9,23.4z"/>
</svg>

      <div>${opts.labelSnippet}</div>`,
      content: `<div class="${snippetRef}" data-gjs-type="${snippetRef}"></div>${style}`,
      category: 'Frequently Used',
      attributes: {
        style: 'order: 8',
      },
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.labelSnippet
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
